<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <navbar>
            <template v-slot:navbarname>
                <b-link
                        :to="{name:'JobUsers'}"
                        class="btn btn-primary btn-round">
                    back
                </b-link>
            </template>
        </navbar>


        <h2>{{user.name}} ({{user.email}})</h2>

        <p v-if="jobLink !== null">promotion link : <a target="_blank" :href="jobLink">{{jobLink}}</a>
            <span class="ml-4" @click="doCopy" style="cursor: pointer">
                <span class="material-icons">content_copy</span>
            </span>
        </p>

        <b-card title="Filter">
            <b-row>
                <b-col cols="12" md="3">
                    <b-form-group label="date from">
                        <date-picker
                                format="YYYY-MM-DD"
                                display-format="YYYY-MM-DD"
                                locale="en" v-model="form.dateFrom"></date-picker>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="3">
                    <b-form-group label="date to">
                        <date-picker
                                format="YYYY-MM-DD"
                                display-format="YYYY-MM-DD"
                                locale="en" v-model="form.dateTo"></date-picker>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="2">
                    <b-form-group label="search">
                        <b-button @click="filterPromotions" variant="success">search</b-button>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="2">
                    <b-form-group label="change promotion">
                        <b-link
                                :to="{name:'UserDetails',params:{'userid':$route.params.id}}"
                                class="btn btn-warning">
                            change
                        </b-link>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="2" v-if="promotions.length > 0">
                    <b-form-group label="print">
                        <b-button @click="myPrint" variant="danger">print</b-button>
                    </b-form-group>
                </b-col>
            </b-row>
        </b-card>
        <!--END Filter-->

        <b-card title="Coupon Codes">
            <div class="accordion" role="tablist">
                <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                        <b-button block v-b-toggle.accordion-1 variant="info">Show Form</b-button>
                    </b-card-header>
                    <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel">
                        <b-card-body>

                            <b-form-group label="codes">
                                <v-select
                                        class="mb-4"
                                        placeholder="select codes"
                                        multiple
                                        :reduce="coupon_name => coupon_name.coupon_name"
                                        label="coupon_name"
                                        v-model="form.coupons"
                                        :options="coupons"></v-select>
                            </b-form-group>
                            <b-button @click="storeTags" variant="success">save</b-button>


                            <div class="table-responsive" v-if="tags.length > 0">
                                <b-table-simple>
                                    <b-thead>
                                        <b-tr>
                                            <b-th>code</b-th>
                                            <b-th>action</b-th>
                                        </b-tr>
                                    </b-thead>

                                    <b-tbody>
                                        <b-tr v-for="(item,index) in tags" :key="index">
                                            <td>
                                                {{item.name}}
                                            </td>
                                            <td>
                                                <a class="text-danger" @click.prevent="deleteTag(item.id)" href="#">delete</a>
                                            </td>
                                        </b-tr>
                                    </b-tbody>

                                </b-table-simple>
                            </div>
                        </b-card-body>
                    </b-collapse>
                </b-card>

            </div>


        </b-card>
        <!--END Coupons-->

        <template v-if="promotions.length > 0">

            <b-card id="printMe">
                <div class="table-responsive">
                    <b-table-simple>
                        <b-thead>
                            <b-tr>
                                <b-th>#</b-th>
                                <b-th>Date</b-th>
                                <b-th>{{$t('order_number')}}</b-th>
                                <b-th>Promotion Prozente</b-th>
                                <b-th>Coupon</b-th>
                                <b-th>Umsatz</b-th>
                                <b-th>Provision</b-th>
                            </b-tr>
                        </b-thead>

                        <b-tbody>
                            <b-tr v-for="(item,index) in promotions" :key="index">
                                <td>{{++index}}</td>
                                <td>
                                    {{item.date}}
                                </td>
                                <td>
                                    <b-link class="font-weight-bold"
                                            :to="{name:'OrderDetails',params:{'orderid':item.order_id}}">
                                        {{item.tracking_number}}
                                    </b-link>
                                </td>
                                <td>
                                    {{item.promotion_percent}} %
                                </td>
                                <td>
                                    {{item.coupon}}
                                </td>
                                <td>
                                    {{item.order_price}}
                                </td>
                                <td>
                                    {{item.promotion_price}}
                                </td>

                            </b-tr>

                            <tr style="border-top: 3px solid #000">
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td>
                                    <strong class="font-weight-bold">{{totalPrice}}</strong>
                                </td>
                                <td>
                                    <strong class="font-weight-bold">{{promotionPrice}}</strong>
                                </td>
                            </tr>
                        </b-tbody>

                    </b-table-simple>
                </div>
            </b-card>
        </template>

    </div>
</template>

<script>
    import Navbar from "../Partials/Navbar";
    import Http from '../../Services/HttpService/HttpService'
    import Nottification from '../../Services/Notification/Nottification'
    import 'vue-select/dist/vue-select.css';


    export default {
        name: "PromotionDetails",
        components: {Navbar},
        data() {
            return {
                coupons: [],
                tags: [],
                promotions: [],
                jobLink: null,
                totalPrice: 0,
                promotionPrice: 0,
                form: {
                    dateFrom: null,
                    dateTo: null,
                    coupons: []
                },
                user: null,
            }
        },
        methods: {
            doCopy() {
                this.$copyText(this.jobLink).then(function (e) {
                    Nottification.success('Copied');
                }, function (e) {
                    Nottification.error('Can not copy');
                })
            },
            myPrint() {
                this.$htmlToPaper('printMe');
            },
            getPromotionDetails() {
                if (this.$route.params.id && this.$route.params.id > 0) {
                    this.$Progress.start();
                    Http.get(Http.apiurl() + 'job/promotion/details/user/' + this.$route.params.id)
                        .then(response => {
                            this.$Progress.finish();
                            if (response.data.status_code === Http.ok()) {
                                this.promotions = response.data.data.promotions;
                                this.jobLink = response.data.data.jobLink;
                                this.totalPrice = response.data.data.totalPrice;
                                this.promotionPrice = response.data.data.promotionPrice;
                                this.user = response.data.data.user;

                                this.getTagsAndCoupons();
                            }
                        })
                        .catch(error => {
                            this.$Progress.finish();
                        })
                }

            },
            getTagsAndCoupons() {
                if (this.$route.params.id && this.$route.params.id > 0) {
                    this.$Progress.start();
                    Http.get(Http.apiurlV2() + 'promotiontag/index/' + this.$route.params.id)
                        .then(response => {
                            this.$Progress.finish();
                            if (response.data.status_code === Http.ok()) {
                                this.tags = response.data.data.tags;
                                this.coupons = response.data.data.coupons;
                            }
                        })
                        .catch(error => {
                            this.$Progress.finish();
                        })
                }

            },
            filterPromotions() {
                if (this.$route.params.id && this.$route.params.id > 0) {

                    if (this.form.dateFrom == null || this.form.dateTo == null) {
                        Nottification.error("Please select date")
                        return;
                    }

                    this.$Progress.start();
                    Http.post(Http.apiurl() + 'job/promotion/details/user/filter', {
                        userid: this.$route.params.id,
                        dateFrom: this.form.dateFrom,
                        dateTo: this.form.dateTo,
                    })
                        .then(response => {
                            this.$Progress.finish();
                            if (response.data.status_code === Http.ok()) {
                                this.promotions = response.data.data.promotions;
                                this.totalPrice = response.data.data.totalPrice;
                                this.promotionPrice = response.data.data.promotionPrice;
                            }
                        })
                        .catch(error => {
                            this.$Progress.finish();
                        })
                }

            },
            storeTags() {
                if (this.$route.params.id && this.$route.params.id > 0) {

                    if (this.form.coupons.length === 0) {
                        Nottification.error("Please select codes")
                        return;
                    }

                    this.$Progress.start();
                    Http.post(Http.apiurlV2() + 'promotiontag/store', {
                        userid: this.$route.params.id,
                        coupons: this.form.coupons,
                    })
                        .then(response => {
                            this.$Progress.finish();
                            if (response.data.status_code === Http.ok()) {
                                this.form.coupons = [];
                                this.getTagsAndCoupons();
                                Nottification.success(response.data.message)
                            }
                        })
                        .catch(error => {
                            this.$Progress.finish();
                        })
                }

            },
            deleteTag(myId) {
                if (confirm("Are you sure to delete this item ?")) {
                    this.$Progress.start();
                    Http.get(Http.apiurlV2() + 'promotiontag/delete/' + myId)
                        .then(response => {
                            this.$Progress.finish();
                            if (response.data.status_code === Http.ok()) {
                                this.getTagsAndCoupons();
                                Nottification.success(response.data.message);
                            }
                        })
                        .catch(error => {
                            this.$Progress.finish();
                        })
                }


            },

        },
        created() {
            this.getPromotionDetails();
        }
    }
</script>

<style scoped>

</style>